import { Typography } from '@mui/material'

import type { FC } from 'react'

interface BusinessContactProps {
	phone?: string
	address?: string
}

export const BusinessContact: FC<BusinessContactProps> = ({ address, phone }) => {
	return (
		<Typography variant="body2" color="text.secondary">
			{phone} {address}
		</Typography>
	)
}
